<div class="modal-header">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <button
    type="button"
    class="accello-icon-btn"
    (mousedown)="isActive = true"
    (mouseup)="isActive = false"
    (mouseleave)="isActive = false"
    (click)="activeModal.dismiss('Cross click')"
  >
    <img
      [src]="
        isActive
          ? 'assets/images/virtusa-icons/close-dark.svg'
          : 'assets/images/virtusa-icons/close.svg'
      " alt="close"
    />
  </button>
</div>

<div class="modal-body d-flex flex-col justify-content-between">
  <div class="rec-banner">
    <div class="rec-title">
      <img
        [src]="'images/virtusa-icons/bulb.svg' | assetUrl"
        alt="bulb"
        class="bulb"
      /><span>Recommended Actions</span>
    </div>
    <span class="accello-general-text14"
      >You can download the attached template and use them as a starting point
      for your own file</span
    >
    <div
      class="sample-file w-100 d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="mb-2 mr-1">
        <img
          [src]="'images/excel.svg' | assetUrl"
          alt="Excel"
          class="excel"
        /><span class="accello-general-text12"
          >Manually Executed Result template
        </span>
      </div>
      <div>
        <img
          [src]="'images/virtusa-icons/download-icon.svg' | assetUrl"
          alt="Excel"
          class="excel-download"
          (click)="downloadTemplate()"
          (keydown.enter)="downloadTemplate()"
        />
      </div>
    </div>
  </div>

  <div class="container">
    <div class="col-md-5 col-1">
      <app-file-upload
        class="mb-2"
        [data]="configs?.file"
        (filesSelected)="handleFilesSelected($event)"
      ></app-file-upload>

      <span class="label">Release Name</span>
      <select
        id="dropdown"
        [(ngModel)]="selectedRelease"
        (change)="onSelectionChange()"
        class="custom-dropdown mb-3"
      >
        <option *ngFor="let sprint of releases" [value]="sprint.value">
          {{ sprint.label }}
        </option>
      </select>
    </div>
    <div class="divider"></div>
    <div class="col-md-5 col-1">
      <div class="d-flex flex-row align-items-center mb-2">
        <div class="d-flex justify-content-between align-items-center flex-row w-100">
          <span class="label">Uploaded Files</span>
          <span class="btn-accello-tertiary" (click)="deleteAllFiles()" (keydown.enter)="deleteAllFiles()">Delete All</span>
        </div>
        <div>
          <div class="release-tag" *ngIf="fileData.length > 0">
            <span>{{ selectedReleaseLabel }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column h-100 w-100">
        @if (isLoading) {
          <app-loading
            class="h-100 loading-container"
            [text]="'Loading'"
          ></app-loading>
        } @else {
          <div
            *ngIf="fileData.length > 0; else noDataTemplate"
            class="file-list"
          >
            <div
              class="mb-2 mr-1 d-flex align-items-center justify-content-between w-100 file-div"
              *ngFor="let item of fileData"
            >
              <div class="d-flex flex-row align-items-center">
                <img
                  [src]="'images/excel.svg' | assetUrl"
                  width="20px"
                  height="20px"
                  alt="Excel"
                  class="excel"
                />
                <div class="file-name-div">
                  <span class="accello-general-text12">{{ item }} </span>
                </div>
              </div>
              <div>
                <img
                  *ngIf="selectedFileToDelete != item"
                  [src]="'images/virtusa-icons/delete.svg' | assetUrl"
                  alt="Excel"
                  class="excel-download"
                  (click)="rollBack(item)"
                  (keydown.enter)="rollBack(item)"
                />
                <img
                  *ngIf="selectedFileToDelete == item"
                  [src]="'images/virtusa-icons/cross.svg' | assetUrl"
                  alt="Excel"
                  class="cross-delete ms-1"
                  (click)="cancelDelete()"
                  (keydown.enter)="cancelDelete()"
                /><img
                  *ngIf="selectedFileToDelete == item"
                  [src]="'images/virtusa-icons/tick.svg' | assetUrl"
                  alt="Excel"
                  class="download-confirm"
                  (click)="deleteFile(item)"
                  (keydown.enter)="deleteFile(item)"
                />
              </div>
            </div>
          </div>
        }
      </div>

      <ng-template #noDataTemplate>
        <app-no-data></app-no-data>
      </ng-template>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn btn-accello-primary-light"
      (click)="upload()"
      [disabled]="isDisabled"
    >
      Upload
    </button>
  </div>
</div>
